import type { VFC } from 'react';
import { type FormProps as AntFormProps, Col, Row, Typography } from 'antd';
import { useTheme } from 'styled-components';
import { FilterForm } from './components/filter/Form';

const { Text } = Typography;

export type FilterProps = AntFormProps;

/**
 * Enmon custom Filter used with Filter Layout to display filter fields
 */
export const Filter: VFC<FilterProps> = props => {
  const { children, onValuesChange, form, initialValues, onFinish } = props;
  const theme = useTheme();

  // TODO: Create text components according to design and typography systems in Figma
  // NOTE: Some styles are hardcoded due to inconsistency in commons theme
  const TITLE_STYLE = {
    fontFamily: theme.font.typography.bodyText.fontFamily,
    fontWeight: theme.font.typography.bodyText.fontWeight.bold,
    fontSize: theme.font.typography.bodyText.fontSize,
    display: 'flex',
    alignItems: 'flex-start',
    color: '#000000',
    letterSpacing: '0.5px',
  } as const;

  return (
    <Row gutter={[0, 6]}>
      <Col span={24}>
        <Row align="middle" justify="space-between" typeof="flex" wrap={false}>
          <Col>
            <Text style={TITLE_STYLE}>Filters</Text>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row>
          <Col span={24}>
            <FilterForm form={form} initialValues={initialValues} onFinish={onFinish} onValuesChange={onValuesChange}>
              {children}
            </FilterForm>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
